const inboxData = [
    
];

export { inboxData };
